import React from 'react';

interface ISummaryState {

    summaryList: {
        date: string;
        machine: string;
        orderId: number;
        product: string;
        grade: string;
        testPlan: string;
        remarks: string;
    }[]
}
export default class Summary extends React.Component<any, ISummaryState>{

    constructor(props: any) {
        super(props);
        this.state = {
            summaryList: [{
                date: "22.1.2021 12:00PM",
                machine: "PM1",
                orderId: 12100,
                product: "Xerox wide paper",
                grade: "160 GSM",
                testPlan: "Migration test plan",
                remarks: "To test brown pager"
            }]
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        )
    }


}